<div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0 overflow-hidden py-6 py-md-12">
    @if (totals$ | async; as totals) {
        @if ((searching$ | async) === true) {
            <div class="py-10">
                <div class="spinner mx-auto"></div>
            </div>
        }
        @if ((error$ | async) === false) {
            @if ((searching$ | async) === false) {
                @if (totals.total !== null && totals.total > 0) {
                    <div class="fs-12 mb-4">
                        {{ 'PRODUCTS.pagination.totals' | translate: { start: totals.start, end: totals.end, total: totals.total } }}
                    </div>
                }
                <!-- Banner -->
                @if ((isSearch$ | async) === false) {
                    @if (totals.total !== null) {
                        <div class="row">
                            <div class="col-7 mb-5 d-none d-lg-block align-self-stretch">
                                <div
                                    class="border rounded-2 category-image"
                                    [style.background-image]="
                                        category && category.imageDetailsView
                                            ? 'url(' + category.imageDetailsView.url + ')'
                                            : 'url(/assets/images/products/all_products_image.jpg )'
                                    "
                                ></div>
                            </div>
                            <div class="mb-5 col-lg-5 col-12">
                                <div
                                    class="bg-secondary py-lg-5 py-6 ps-md-6 pe-md-4 px-8 h-100 d-flex flex-column justify-content-center word-wrap-break-word"
                                >
                                    <h1 class="text-white fs-39 fw-700 word-wrap-break">
                                        {{ category ? category.name : ('PRODUCTS.box.title' | translate) }}
                                    </h1>
                                    <p class="text-gray-300 lh-29 word-wrap-break">
                                        {{ category ? category.description : ('PRODUCTS.box.description' | translate) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                }
                <!-- Desktop listing -->
                @if ((isSearch$ | async) === false) {
                    @for (products of productsRows$ | async; track products; let index = $index) {
                        <div class="d-none d-lg-block">
                            @if (index % 2 === 0) {
                                <app-products-row-type-1 [products]="products"></app-products-row-type-1>
                            }
                            @if (index % 2 === 1) {
                                <app-products-row-type-2 [products]="products"></app-products-row-type-2>
                            }
                        </div>
                    }
                    @if (totals.total === 0) {
                        <div class="d-flex align-items-center justify-content-center border rounded-2 h-100">
                            {{ 'PRODUCTS.product_categories.nothing_found' | translate }}
                        </div>
                    }
                }
                @if ((isSearch$ | async) === true) {
                    @for (products of productsRows$ | async; track products; let index = $index) {
                        <div class="d-none d-lg-block">
                            @if (index % 2 === 0) {
                                <app-products-row-type-1 [products]="products"></app-products-row-type-1>
                            }
                            @if (index % 2 === 1) {
                                <app-products-row-type-2 [products]="products"></app-products-row-type-2>
                            }
                        </div>
                    }
                }
                <!-- Mobile/tablet listing -->
                <div class="d-lg-none row gx-3">
                    @for (product of products$ | async; track product) {
                        <div class="col-6 mx-auto col-md-4 mb-5">
                            <app-product-thumbnail [isBig]="false" [product]="product"></app-product-thumbnail>
                        </div>
                    }
                </div>
                @if ((isSearch$ | async) === true) {
                    @if ((productsRows$ | async)?.length === 0) {
                        <div class="text-center">
                            {{ 'PRODUCTS.nothing-found' | translate: { q: (searchQuery$ | async) } }}
                        </div>
                    }
                }
                <app-pagination [total]="(totals$ | async)?.total ?? 0" [limit]="limit" (pageChanged)="onPageChange($event)"></app-pagination>
            }
        }
        @if ((error$ | async) === true) {
            {{ 'PRODUCTS.unknown-error' | translate }}
        }
    }
</div>
